module.exports = __webpack_public_path__ + "img/117.f4de8ec8.jpg";